import initials from 'initials'
import PropTypes from 'prop-types'

export default function TalentBadge({ talentName }) {
  return (
    <div className='relative flex items-center justify-center'>
      <svg
        width='30px'
        height='30px'
        viewBox='0 0 30 30'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
      >
        <defs>
          <rect
            id='path-8w9h5cs0wg-1'
            x='0'
            y='0'
            width='30'
            height='30'
            rx='6'
          ></rect>
        </defs>
        <g
          id='Page-1'
          stroke='none'
          strokeWidth='1'
          fill='none'
          fillRule='evenodd'
        >
          <g id='Oval'>
            <rect
              id='Rectangle'
              fill='#29CCC7'
              fillRule='nonzero'
              x='0'
              y='0'
              width='30'
              height='30'
              rx='6'
            ></rect>
            <g id='Clipped'>
              <mask id='mask-8w9h5cs0wg-2' fill='white'>
                <use xlinkHref='#path-8w9h5cs0wg-1'></use>
              </mask>
              <g id='Rectangle'></g>
              <g id='Group' mask='url(#mask-8w9h5cs0wg-2)' fillRule='nonzero'>
                <g transform='translate(-27.750000, -2.250000)' id='Oval'>
                  <circle
                    fill='#A2E3FF'
                    cx='24.75'
                    cy='37.5'
                    r='24.75'
                  ></circle>
                  <circle
                    fill='#4D7BF3'
                    cx='64.875'
                    cy='31.875'
                    r='31.875'
                  ></circle>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
      <span className='absolute text-base font-semibold uppercase text-white'>
        {initials(talentName)}
      </span>
    </div>
  )
}

TalentBadge.propTypes = {
  talentName: PropTypes.string.isRequired
}
